import {Component, OnInit} from '@angular/core';

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var i18nVS: any;
declare var initMap: any;
declare var moveUserPosition: any;
declare var nombreOrigen: any;
declare var nombreDestino: any;
declare var colorLineaClicada: any;
declare var idLineaClicada: any;
declare var activeStopsGlobal: any;

@Component({
	selector: 'app-service-information-mapa',
	templateUrl: './mapa.component.html',
	styleUrls: ['../service-information.component.css']
})

export class MapaComponent implements OnInit {
	i18nL = i18nVS;
	origen = '';
	destino = '';
	idLinea = '';
	colorLinea = '#FF0000';
	firstLoad = true;

	/*----------------------------------------------- Funciones ----------------------------------------------------*/
	public poblarVariables() {
		this.origen = nombreOrigen;
		this.destino = nombreDestino;
		this.colorLinea = colorLineaClicada;
		this.idLinea = idLineaClicada;
	}

	public crearMapa() {
		this.poblarVariables();
		initMap();
	}

	public crearMapaCoroutine() {
		if (typeof activeStopsGlobal !== 'undefined') {
			this.crearMapa();
		} else {
			setTimeout(() => this.crearMapaCoroutine(), 250);
		}
	}

	/*--------------------------------------------- Eventos ------------------------------------------------------*/
	ngOnInit() {
		this.crearMapaCoroutine();
	}

	/*--------------------------------------------- Constructores ------------------------------------------------*/
	constructor() {
	}
}



// WEBPACK FOOTER //
// ./src/app/mapa/mapa.component.ts